"use client";

import React from "react";
import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactData = [{
  id: 1,
  type: "address",
  title: "Visit us",
  description: "Visit our office headquarters.",
  detail: "3 Memorial Ave, Pawling, NY 12564"
}, {
  id: 2,
  type: "phone",
  title: "Call us",
  description: "Mon-Fri from 8am to 5pm.",
  detail: "+1 (914) 203-1833"
}, {
  id: 3,
  type: "email",
  title: "Chat to us",
  description: "Our friendly team is here to help.",
  detail: "info@qstgeo.com"
}];
export default function MapContactDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}